import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=7aa8f7a5&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style1 from "./menu.vue?vue&type=style&index=1&id=7aa8f7a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8f7a5",
  null
  
)

export default component.exports